import { render, staticRenderFns } from "./MainNewContents04.vue?vue&type=template&id=b1bb83d2&scoped=true"
import script from "./MainNewContents04.vue?vue&type=script&lang=js"
export * from "./MainNewContents04.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bb83d2",
  null
  
)

export default component.exports